import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { createCourseCollectionService } from 'src/api/collection'
import { createCollectionSuccess } from 'src/reducers/collection/action'
import { CREATE_COLLECTION } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* createCollectionFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(createCourseCollectionService, entity)
    yield put(createCollectionSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* createCollectionWatcher() {
  while (true) {
    const action = yield takeMaybe(CREATE_COLLECTION)
    const { payload } = action

    yield fork(generalSaga, createCollectionFlow, payload)
  }
}
